import React, { FC } from "react";
import styles from "./SegmentedProgressCircle.module.scss";

interface Props {
    radius: number;
    cx: number;
    cy: number;
    strokeWidth: number;
    progress: number;
    value: number | string;
    title: string;
    titleSecondary?: string;
    circleColor?: string;
    darkMode: boolean;
}

export const SegmentedProgressCircle: FC<Props> = ({
    radius,
    cx,
    cy,
    strokeWidth,
    progress,
    value,
    title,
    titleSecondary,
    circleColor,
    darkMode
}) => {
    const level = Math.max(0, Math.min(10, progress));
    const textModeClass = darkMode ? styles.dark : styles.light;
    const segments = 20;
    const circumference = 2 * Math.PI * radius;
    let backgroundStyle = "";
    const gap = 5.75;
    const segment = circumference / 20 - gap;
    for (let i = 0; i < segments; i++) {
        backgroundStyle += ` ${segment} ${gap} `;
    }
    const dashOffset = gap / 2 - strokeWidth - 1;
    let strokeArray: string;
    if (level < 0.5) {
        strokeArray = `${level} 0 1 1000`;
    } else {
        const size = Math.round(level) * 2;
        strokeArray = `${(circumference / segments) * size - gap * 2} 0 ${gap} 1000`;
    }
    return (
        <div>
            <div className={styles.wrapper}>
                <div className={`${styles.text} ${textModeClass}`}>
                    <div className={styles.primary}>{value}</div>
                    <div className={styles.secondary}>{title}</div>

                    {titleSecondary ? (
                        <div className={styles.secondary}>{titleSecondary}</div>
                    ) : null}
                </div>

                <div className={styles.circles}>
                    <svg>
                        <circle
                            r={radius}
                            cy={cy}
                            cx={cx}
                            strokeWidth={strokeWidth}
                            className={styles.background}
                            style={{
                                strokeDasharray: backgroundStyle
                            }}
                            strokeDashoffset={dashOffset}
                        />
                        <circle
                            r={radius}
                            cy={cy}
                            cx={cx}
                            strokeWidth={strokeWidth}
                            stroke={circleColor ? circleColor : "#19e27a"}
                            className={`${styles.progress}`}
                            style={{
                                strokeDasharray: strokeArray
                            }}
                            strokeDashoffset={dashOffset}
                        />
                    </svg>
                </div>
            </div>
        </div>
    );
};
